import { ComponentProps } from "react";

import { Step } from "../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import NoToAllFormSeriesMedicalStepDecorator from "../Components/NoToAllFormSeriesMedicalStepDecorator";
import { FormSeriesMedicalStepInnerContent, IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import AllMedicalQuestionsEvaluator from "./AllMedicalQuestionsEvaluator";
import { ComposedAllMedicalQuestions } from "./ComposedAllMedicalQuestions";
import { DiabeticFormEvaluatorConfig } from "./ComposedDiabeticMedicalQuestions";
import { GeneralMedicalQuestionsEvaluatorConfig } from "./ComposedGeneralMedicalQuestions";
import { PacemakerFormEvaluatorConfig } from "./ComposedPacemakerMedicalQuestions";
import { RadiationFormEvaluatorConfig } from "./ComposedRadiationMedicalQuestions";
import ComposedUseCreateMedicalNonCanContactResult from "./ComposedUseCreateMedicalNonCanContactResult";

const allMedicalQuestionEvaluatorConfigs = [
  GeneralMedicalQuestionsEvaluatorConfig,
  PacemakerFormEvaluatorConfig,
  RadiationFormEvaluatorConfig,
  DiabeticFormEvaluatorConfig
];

const allMedicalQuestionIds = Array.from(
  new Set(allMedicalQuestionEvaluatorConfigs.flatMap(config => config.allFormQuestionIds))
);

const nestedMedicalQuestionIds = Array.from(
  new Set(allMedicalQuestionEvaluatorConfigs.flatMap(config => Object.keys(config.requiredQuestionPredicates ?? {})))
);

const nestedMedicalQuestionIdSet = new Set(nestedMedicalQuestionIds);

const rootMedicalQuestionIds = allMedicalQuestionIds.filter(questionId => !nestedMedicalQuestionIdSet.has(questionId));

const ConfiguredAllMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  NoToAllFormSeriesMedicalStepDecorator({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: AllMedicalQuestionsEvaluator,
    FormQuestions: ComposedAllMedicalQuestions,
    useCreateNonCandidateContactResult: ComposedUseCreateMedicalNonCanContactResult,
    InnerForm: FormSeriesMedicalStepInnerContent,
    rootMedicalQuestionIds,
    nestedMedicalQuestionIds
  });

const ComposedAllMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredAllMedicalStep>
>({
  Component: ConfiguredAllMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSavePatientNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSavePatientNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedAllMedicalStep;
